import AgGridWrapper from "./AgGridWrapper";

export default AgGridWrapper;



// WEBPACK FOOTER //
// ./src/components/AgGridWrapper/index.js